export const selectedCrop = (state) => {
  return state.crops.allCrops.find(crop => crop.value === state.crops.selectedCropValue) || null
}
